import React, { useState, useEffect } from "react";
import { styled, spacing, SpacingProps } from "@mui/system";
import {
  Box as Muibox,
  Button as MuiButton,
  Typography as MuiTypography
} from "@mui/material";
import { Breadcrumbs } from "@rewardle/apps.ui.breadcrumbs.breadcrumbs";
import { Searchbox } from "@rewardle/apps.ui.searchbox.searchbox";
import { CustomDataTable } from "@rewardle/apps.ui.customdatatable.customdatatable";
import { Loader } from "@rewardle/apps.ui.loader.loader";
import { Papercontainer } from "@rewardle/apps.ui.papercontainer.papercontainer";
import { getuserslist } from "@rewardle/apps.utils.getuserslist";

export type UsersearchProps = {
  searchUserColumns: any;
  accessToken: string;
  apiBaseUrl: string;
  handleRowClick?: (row: any) => void;
};

interface ButtonProps extends SpacingProps {
  component?: React.ElementType;
  to?: string;
  target?: string;
}

const BoxTitle = styled(Muibox)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const Button = styled(MuiButton)<ButtonProps>`
  ${spacing}

  &.custom_disabled {
    background-color: grey !important;
  }
`;

const SearchBoxContainer = styled(Muibox)`
  display: flex;
  gap: 10px;
  align-items: baseline;
`;

const TypographyTitle = styled(MuiTypography)`
  color: var(--light-text-dark, rgba(0,0,0,0.88)));
  font-family: 'Montserrat',sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
const Typography = styled(MuiTypography)``;

export function Usersearch({
  searchUserColumns,
  accessToken,
  apiBaseUrl,
  handleRowClick = (val: any) => {}
}: UsersearchProps) {
  const [searchQuery, setSearchQuery] = useState<any>("");
  const [responseData, setResponseData] = useState<any>([]);
  const [apiStatus, setApiStatus] = useState<any>("");
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  console.log("Usersearch");

  useEffect(() => {
    if (searchQuery) setIsSaveDisabled(false);
    else setIsSaveDisabled(true);
  }, [searchQuery]);

  const handleSearch = (userSearchQuery: string) => {
    localStorage.removeItem("isUserBackToUserSearchPage");
    setApiStatus("fetching");
    getuserslist(accessToken, apiBaseUrl, userSearchQuery)
      .then((res) => {
        console.log("🚀 ~ .then ~ res:", res);
        setResponseData(res);
        setApiStatus("idle");
        localStorage.setItem("isUserSearchString", userSearchQuery);
      })
      .catch((err) => {
        setResponseData([]);
        setApiStatus("failed");
      });
  };

  useEffect(() => {
    let isUserBackToUserSearchPage = localStorage.getItem(
      "isUserBackToUserSearchPage"
    );
    let isUserSearchString = localStorage.getItem("isUserSearchString");
    if (isUserBackToUserSearchPage && isUserSearchString) {
      setSearchQuery(isUserSearchString);
      handleSearch(isUserSearchString);
    }
  }, []);

  const callBack = (e: any) => {
    if (searchQuery) handleSearch(searchQuery);
  };
  return (
    <>
      <Breadcrumbs heading="Search User" subHeading="" docs={undefined} />
      <Papercontainer elevation={0}>
        <TypographyTitle>
          {"Search User by id, email, name, mobile, or qrcode"}
        </TypographyTitle>
        <BoxTitle>
          <SearchBoxContainer>
            <Searchbox
              label="Search"
              variant="outlined"
              value={searchQuery}
              setSearchTerm={setSearchQuery}
              callBack={callBack}
            />
            <Button
              variant="contained"
              color="secondary"
              mt={2}
              onClick={() => handleSearch(searchQuery)}
              className={
                isSaveDisabled ? "blue_button custom_disabled" : "blue_button"
              }
              disabled={isSaveDisabled}
            >
              Search
            </Button>
          </SearchBoxContainer>
        </BoxTitle>
        {responseData?.length > 0 &&
        apiStatus !== "fetching" &&
        apiStatus !== "failed" ? (
          <CustomDataTable
            rows={responseData}
            columns={searchUserColumns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 }
              }
            }}
            pageSizeOptions={[10, 50, 100]}
            onRowClick={handleRowClick}
            getRowId={"UserId"}
          />
        ) : apiStatus === "fetching" ? (
          <Loader />
        ) : (
          <Typography variant="h5" mb={2} align="center">
            {"No Data Available"}
          </Typography>
        )}
      </Papercontainer>
    </>
  );
}
